$(function () {
    if ($(".s31-embrodiery-form .required").hasClass("error")) {
        $('html, body').animate({
			scrollTop: $(".s31-embrodiery-form").offset().top
		}, 2000);
    }
});